import { useState, useEffect } from 'react';
import { blogAPI, contactAPI, transformRecords } from '../services/airtable';

// Generic hook for data fetching
export const useAirtable = (apiFunction, transformData = true) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await apiFunction();
        const finalData = transformData ? transformRecords(response.records) : response;
        setData(finalData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [apiFunction, transformData]);

  return { data, loading, error };
};

// Specific hooks
export const useBlogPosts = () => useAirtable(blogAPI.getAll);
export const useContactSubmit = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const submitForm = async (formData) => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);
      await contactAPI.submit(formData);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { submitForm, loading, error, success };
};